module.exports = __webpack_public_path__ + "static/media/logo_bacabank.d9dc5cda.svg";